export default {
  ADMINISTRADOR: 'administrador',
  LIDER: 'lider',
  ATENDENTE: 'atendente',
  BARBEIRO: 'barbeiro',
  BARBEIRO_CAIXA: 'barbeiro_caixa',
}
